import React, { useEffect, useState } from "react";
import {courseApi} from "../api/courseApi";
import {mediaRecordingsApi} from "../api/mediaRecordingsApi";
import {Spinner} from "../controls/spinner";
import {Menu} from "../menu/menu";
import {MeetingRecordings} from "./meetingRecordingsList";
import homeStyle from '../main/home.scss';

const mongoIdPattern = /^[0-9a-fA-F]{24}$/;

export function VideoRecordings(props) {
  const recordingId = props.match.params.recordingId;
  const [meeting, setMeeting] = useState(undefined);
  const [recordings, setRecordings] = useState(null);

  useEffect(() => {
    if (recordingId) {
      fetchMeeting();
    } else {
      setMeeting(null);
      fetchRecordingsFromAWS();
    }
  }, []);

  async function fetchMeeting() {
    const m = mongoIdPattern.test(recordingId) ? await courseApi.getMeetingById(recordingId) : null;
    if (m) {
      setMeeting(m);
      return;
    }
    const recordings = await mediaRecordingsApi.searchMediaRecordingsByMeetingId(recordingId);
    if (recordings && recordings.length > 0) {
      setMeeting({_id: recordingId});
    } else {
      setMeeting(null);
      fetchRecordingsFromAWS();
    }
  }

  async function fetchRecordingsFromAWS() {
    let recs;
    if (recordingId) {
      recs = await courseApi.getRecordingsForId(recordingId);
    } else {
      recs = await courseApi.listAllRecordings();
    }
    setRecordings(recs);
  }

  return (
    <div className={homeStyle.home}>
      <Menu/>
      <div className={homeStyle.list}>
        {meeting === undefined && <Spinner/>}
        {meeting && <MeetingRecordings meeting={meeting}/>}
        {meeting === null &&
          <div style={{display: "flex", flexDirection: "column", width: "100%", justifyContent: "center", marginTop: "48px"}}>
            {!recordings && <Spinner/>}
            {recordings && recordings.length > 0 &&
              <table style={{border: "1px solid black"}}>
                {
                  recordings.map((r) => (
                    <tr>
                      <td style={{padding: "24px"}}>{r.name}</td>
                      <td><a href={r.url} target={"_blank"}>Play</a></td>
                    </tr>
                  ))
                }
              </table>
            }
            {recordings && recordings.length === 0 &&
              <>
                No recordings found for id {recordingId}
              </>
            }
          </div>
        }
      </div>
    </div>
  )
}